import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import StudentDashboard from '../components/StudentDashboard';
import { CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';

const StudentDashboardPage: React.FC = () => {
  const { student, isLoading } = useAuth();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '400px' }}>
        <CircularProgress />
      </div>
    );
  }

  if (!student) {
    return <div>{t('studentDashboard.errors.studentNotFound')}</div>;
  }

  return <StudentDashboard student={student} />;
};

export default StudentDashboardPage;

